export const MERGE = "mergeState";
export const RESET_MODAL_AGENT = "resetModalAgent";
export const SET_MODAL_AGENT = "setModalAgent";
export const RESET_CONTACT_FORM_TYPE = "resetContactFormType";
export const SET_CONTACT_FORM_TYPE = "setContactFormType";
export const SET_WHAT_YOU_SHOULD_KNOW_MODAL = "setWhatYouShouldKnowModal";
export const RESET_MESSAGE_SCREENING_FLAG = "resetMessageScreeningFlag";
export const SET_MESSAGE_SCREENING_FLAG = "setMessageScreeningFlag";
export const SET_QUESTIONNAIRE_TOTAL_STEPS = "setQuestionnaireTotalSteps";
export const RESET_QUESTIONNAIRE_STEP = "resetQuestionnaireStep";
export const SET_NEXT_QUESTIONNAIRE_STEP = "setNextQuestionnaireStep";
export const RESET_POST_SUBMIT_ANSWERS = "resetPostSubmitAnswers";
export const SET_POST_SUBMIT_ANSWERS = "setPostSubmitAnswers";
